export const QUERY_SET = 'QUERY_SET';

export const setQuery = (table, data) => ({
    type: QUERY_SET,
    table,
    data,
});
